module.exports = __webpack_public_path__ + "img/scene8_3.d6c32cad.svg";